import { createReducer, on } from '@ngrx/store';

import { SearchActions } from './search.actions';
import { SearchListState } from './search.state';

export const initSearchState: SearchListState = {
  searchList:
    JSON.parse(
      localStorage.getItem('searchHistoryList') ? localStorage.getItem('searchHistoryList') : null
    ) || [],
};

export const searchReducer = createReducer(
  initSearchState,

  on(
    SearchActions.ListSearchSuccess,
    (state, { payload }): SearchListState => ({
      ...state,
      ...payload,
    })
  )
);
